import { defineMessages } from 'react-intl';

export default defineMessages({
  previewMode: {
    id: 'widget.preview-prompt.preview-mode',
    defaultMessage: 'Preview Mode',
  },
  youInPreview1: {
    id: 'widget.preview-prompt.you-in-preview.line1',
    defaultMessage: 'Hey, you’re in Preview mode.',
  },
  youInPreview2: {
    id: 'widget.preview-prompt.you-in-preview.line2',
    defaultMessage: 'This feature works on your live site once it’s published.',
  },
  gotIt: {
    id: 'widget.preview-prompt.got-it',
    defaultMessage: 'Got it!',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/preview-prompt/translations.js